import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const QuickInterviewActions = {

  // RELATED TO QUICK INTERVIEW STEPS

  getQuickInterviewsSteps: async ({ commit }) => {
    return axiosRequest.get('quick_interviews/steps').
      then(({ data }) => { commit('setQuickInterviewsSteps', data) }).
      catch(handleError)
  },

  getQuickInterviewsStep: async ({ commit }, id) => {
    return axiosRequest.get(`quick_interviews/steps/${id}`).
      then(({ data }) => { commit('setQuickInterviewsStep', data) }).
      catch(handleError)
  },

  createQuickInterviewsStep: async ({ commit }, params) => {
    return axiosRequest.post('quick_interviews/steps', { quick_interview_step: params }).
      then(({ data }) => { commit('setQuickInterviewsStep', data) }).
      catch(handleError)
  },

  updateQuickInterviewsStep: async ({ commit }, params) => {
    return axiosRequest.patch(`quick_interviews/steps/${params.id}`, { quick_interview_step: params }).
      then(({ data }) => { commit('updateQuickInterviewsStep', data) }).
      catch(handleError)
  },

  destroyQuickInterviewsStep: async ({ commit }, id) => {
    return axiosRequest.delete(`quick_interviews/steps/${id}`).
      then(({ data }) => { commit('removeQuickInterviewsStep', data) }).
      catch(handleError)
  },

  // RELATED TO QUICK INTERVIEWS

  listQuickInterviews: async ({ commit }, params) => {
    return axiosRequest.get('quick_interviews', { params }).
      then(({ data }) => { commit('setQuickInterviewsList', data) }).
      catch(handleError)
  },

  createQuickInterview: async ({ commit, state }, { partyData, partyId }) => {
    commit('resetQuickInterview')

    return axiosRequest.post('quick_interviews', {
      initial_party_data: partyData,
      steps_data: state.quickInterview.steps_data,
      last_step_index: 0,
      last_step_title: state.quickInterview.steps_data[0].title,
      party_id: partyId,
    }).
      then(({ data }) => {
        commit('setQuickInterview', data)
      }).
      catch(handleError)
  },

  resumeQuickInterview: async ({ commit }, interviewId) => {
    commit('resetQuickInterview')

    return axiosRequest.get(`quick_interviews/${interviewId}`).
      then(({ data }) => commit('setQuickInterview', data)).
      catch(handleError)
  },

  updateQuickInterview: async ({ commit, state }, partyData) => {
    return axiosRequest.patch(`quick_interviews/${state.quickInterview.id}`, {
      updated_party_data: partyData,
      steps_data: state.quickInterview.steps_data,
      last_step_index: state.quickInterview.last_step_index,
      last_step_title: state.quickInterview.last_step_title,
    }).
      then(({ data }) => { commit('setQuickInterview', data) }).
      catch(handleError)
  },

  closeQuickInterview: async ({ commit }, id) => {
    return axiosRequest.post(`quick_interviews/${id}/close`).
      then(({ data }) => { commit('updateQuickInterview', data) }).
      catch(handleError)
  },

  finishQuickInterview: async ({ commit, state }, partyData) => {
    return axiosRequest.post(`quick_interviews/${state.quickInterview.id}/finish`, {
      updated_party_data: partyData,
      steps_data: state.quickInterview.steps_data,
      last_step_index: state.quickInterview.last_step_index,
      last_step_title: state.quickInterview.last_step_title,
    }).
      then(({ data }) => { commit('setQuickInterview', data) }).
      catch(handleError)
  },

  resetQuickInterviewTimeout: async ({ commit, state }) => {
    return axiosRequest.post(`quick_interviews/${state.quickInterview.id}/reset_timeout`).
      then(({ data }) => { commit('updateQuickInterview', data) }).
      catch(handleError)
  },
}
